import PropTypes from 'prop-types';
import moment from "moment";

export const EventProps = PropTypes.shape({
  id: PropTypes.string,
  entityId: PropTypes.string,
  entityType: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  typeDescription: PropTypes.string,
  feeDescription: PropTypes.string,
  frequencyRateDescription: PropTypes.string,
  scopeDescription: PropTypes.string,
  ageGroup: PropTypes.string,
  registrationRequired: PropTypes.bool,
  adaAccess: PropTypes.string,
  comments: PropTypes.string,
  email: PropTypes.string,
  url: PropTypes.string,
  urlText: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  sponsorName: PropTypes.string,
  sponsorClassType: PropTypes.string,
  sponsorPhone: PropTypes.string,
  sponsorEmail: PropTypes.string,
  sponsorUrl: PropTypes.string,
  sponsorUrlText: PropTypes.string
});

export const EventDefaults = {
  id: "",
  entityId: "",
  entityType: "",
  name: "",
  description: "",
  typeDescription: "",
  feeDescription: "",
  frequencyRateDescription: "",
  scopeDescription: "",
  ageGroup: "",
  registrationRequired: false,
  adaAccess: "",
  comments: "",
  email: "",
  url: "",
  urlText: "",
  startDate: moment().format("YYYY-MM-DD"),
  endDate: moment().format("YYYY-MM-DD"),
  sponsorName: "",
  sponsorClassType: "",
  sponsorPhone: "",
  sponsorEmail: "",
  sponsorUrl: "",
  sponsorUrlText: ""
};
